import customFetch from "utils/customFetch";
import { existingHeaders } from "./utils";
import { getAuthUrl } from "utils/env";

const CUSTOMER_ENDPOINT = "/customer";
const EMAIL_VERIFICATION_ENDPOINT = "/customer/registration/email-verification";
const REQUEST_OTP_ENDPOINT = "/customer/registration/request-otp";
const VALIDATE_OTP_ENDPOINT = "/customer/registration/validate-otp";
const VALIDATE_TOKEN_ENDPOINT = "/customer/validate/token";

export const registrationService = {
  requestOtp,
  validateOtp,
  verifyEmail,
  checkToken,
  register,
};

const requestOptions = {
  credentials: "same-origin",
  headers: existingHeaders,
  method: "POST",
};

function requestOtp(email) {
  return fetch(getAuthUrl(REQUEST_OTP_ENDPOINT), {
    ...requestOptions,
    body: JSON.stringify({ email }),
  });
}

function validateOtp(otp_code, email) {
  return fetch(getAuthUrl(VALIDATE_OTP_ENDPOINT), {
    ...requestOptions,
    body: JSON.stringify({ email, otp_code }),
  });
}

function verifyEmail(email) {
  return fetch(getAuthUrl(EMAIL_VERIFICATION_ENDPOINT), {
    ...requestOptions,
    method: "PUT",
    body: JSON.stringify({ email }),
  });
}

function checkToken(token) {
  return fetch(getAuthUrl(VALIDATE_TOKEN_ENDPOINT), {
    ...requestOptions,
    body: JSON.stringify({ email_verification_token: token }),
  });
}

function register(data, token) {
  return customFetch(getAuthUrl(CUSTOMER_ENDPOINT), {
    method: "POST",
    headers: { "X-Verification-Token": token },
    body: JSON.stringify(data),
  });
}
